import {
    Box,
    Checkbox,
    TableCell,
    TableHead,
    TableRow,
    TableSortLabel,
} from "@mui/material";
import { useState } from "react";

export default function MuiTableHead(props) {
    const {
        order,
        orderBy,
        onRequestSort,
        selectedColumns,
        headCells,
        onCheckAll,
    } = props;

    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    const [checkAll, setCheckAll] = useState(false);

    const handleChange = (event) => {
        setCheckAll(event.target.checked);

        onCheckAll(event.target.checked);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((item, index) => {
                    return (
                        selectedColumns.includes(item.id) && (
                            <TableCell
                                key={item.id}
                                align={item.numeric ? "right" : "left"}
                                padding={
                                    item.disablePadding ? "none" : "normal"
                                }
                                sortDirection={
                                    orderBy === item.id ? order : false
                                }
                                title={item.headerTooltip ?? ""}
                            >
                                <Box display={"flex"} alignItems={"center"}>
                                    {index === 0 && item.checkbox && (
                                        <Checkbox
                                            checked={checkAll}
                                            inputProps={{
                                                "aria-label": "controlled",
                                            }}
                                            onChange={handleChange}
                                        />
                                    )}
                                    {item.sort && (
                                        <TableSortLabel
                                            active={orderBy === item.id}
                                            direction={
                                                orderBy === item.id
                                                    ? order
                                                    : "asc"
                                            }
                                            onClick={createSortHandler(item.id)}
                                            sx={{ fontWeight: 600 }}
                                        >
                                            {item.label}
                                        </TableSortLabel>
                                    )}
                                    {!item.sort && item.label}
                                </Box>
                            </TableCell>
                        )
                    );
                })}
            </TableRow>
        </TableHead>
    );
}
